"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChaCha20js = void 0;
var chacha = require('chacha-js/browser');
const strings_1 = require("../../util/strings");
class ChaCha20js {
    encryptHex(message, key, nonce) {
        let keyBuf = Buffer.from(key, 'hex');
        let nonceBuf = Buffer.from(nonce, 'hex');
        return this.encrypt(message, keyBuf, nonceBuf, 'utf8', 'hex');
    }
    decryptHex(ciphertext, key, nonce) {
        let keyBuf = Buffer.from(key, 'hex');
        let nonceBuf = Buffer.from(nonce, 'hex');
        return this.decrypt(ciphertext, keyBuf, nonceBuf, 'hex', 'utf8');
    }
    encryptBase64(message, key, nonce) {
        let keyBuf = Buffer.from(strings_1.Strings.base64toHex(key), 'hex');
        let nonceBuf = Buffer.from(strings_1.Strings.base64toHex(nonce), 'hex');
        return this.encrypt(message, keyBuf, nonceBuf, 'utf8', 'base64');
    }
    decryptBase64(ciphertext, key, nonce) {
        let keyBuf = Buffer.from(strings_1.Strings.base64toHex(key), 'hex');
        let nonceBuf = Buffer.from(strings_1.Strings.base64toHex(nonce), 'hex');
        return this.decrypt(ciphertext, keyBuf, nonceBuf, 'base64', 'utf8');
    }
    encrypt(message, key, nonce, inputFmt, outputFmt) {
        let cipher = chacha.chacha20(key, nonce);
        let result = cipher.update(message, inputFmt, outputFmt);
        cipher.final();
        return result;
    }
    decrypt(message, key, nonce, inputFmt, outputFmt) {
        let decipher = chacha.chacha20(key, nonce);
        let result = decipher.update(message, inputFmt, outputFmt);
        decipher.final();
        return result;
    }
}
exports.ChaCha20js = ChaCha20js;
//# sourceMappingURL=ChaCha20js.js.map